export const SiteEvents = {
  cartUpdate: 'cart-update',
  transitionStart: 'transition-start',
  transitionEnd: 'transition-end',
  enterAnimationStart: 'enter-animation-start',
}

/**
 * Event fired when the cart is updated
 * @extends {Event}
 */
export class CartUpdateEvent extends Event {
  constructor(cart) {
    super(CartUpdateEvent.eventName, { bubbles: true });
    this.cart = cart;
  }

  static eventName = SiteEvents.cartUpdate;
}

/**
 * Event fired when the transition starts
 * @extends {Event}
 */
export class TransitionStartEvent extends Event {
  constructor() {
    super(TransitionStartEvent.eventName, { bubbles: true });
  }

  static eventName = SiteEvents.transitionStart;
}

/**
 * Event fired when the transition ends
 * @extends {Event}
 */
export class TransitionEndEvent extends Event {
  constructor() {
    super(TransitionEndEvent.eventName, { bubbles: true });
  }

  static eventName = SiteEvents.transitionEnd;
}

/**
 * Event fired when the page changes
 * @extends {Event}
 */
export class EnterAnimationStartEvent extends Event {
  constructor() {
    super(EnterAnimationStartEvent.eventName, { bubbles: true });
  }
}